import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/api/client";

export function useAddLocationToDA(siteId: string, daCode: string) {
  const qc = useQueryClient();
  return useMutation<unknown, Error, { daId: string; locationId: string }>({
    mutationFn: ({ daId, locationId }) =>
      apiRequest(
        `/api/sites/${siteId}/disease-areas/${daId}/locations/${locationId}`,
        { method: "POST" },
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["sites", siteId, "clinops", daCode] });
      qc.invalidateQueries({ queryKey: ["sites", siteId] });
    },
  });
}

export function useRemoveLocationFromDA(siteId: string, daCode: string) {
  const qc = useQueryClient();
  return useMutation<void, Error, { daId: string; locationId: string; reason: string }>({
    mutationFn: ({ daId, locationId, reason }) =>
      apiRequest<void>(
        `/api/sites/${siteId}/disease-areas/${daId}/locations/${locationId}`,
        { method: "DELETE", body: JSON.stringify({ reason }) },
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["sites", siteId, "clinops", daCode] });
      qc.invalidateQueries({ queryKey: ["sites", siteId] });
    },
  });
}
